import type { ReactNode } from 'react';
import {
  ExpandableScreen,
  ExpandableScreenContent,
  ExpandableScreenTrigger,
  useExpandableScreen,
} from '@/components/ui/expandable-screen';
import WaitlistForm from './WaitlistForm';

function WaitlistModalContent() {
  const { collapse } = useExpandableScreen();
  return (
    <ExpandableScreenContent
      className="bg-black text-white"
      closeButtonClassName="text-white bg-white/10 hover:bg-white/20"
    >
      <WaitlistForm onClose={collapse} />
    </ExpandableScreenContent>
  );
}

interface WaitlistModalTriggerProps {
  /** Must be unique per trigger on the page (framer-motion layoutId is global). */
  layoutId: string;
  triggerRadius?: string;
  children: ReactNode;
}

/**
 * Wraps a trigger button so clicking it morphs into the waitlist form in a
 * full-screen modal (via ExpandableScreen), instead of navigating to /waitlist.
 */
export default function WaitlistModalTrigger({
  layoutId,
  triggerRadius = '100px',
  children,
}: WaitlistModalTriggerProps) {
  return (
    <ExpandableScreen layoutId={layoutId} triggerRadius={triggerRadius} contentRadius="24px">
      <ExpandableScreenTrigger>{children}</ExpandableScreenTrigger>
      <WaitlistModalContent />
    </ExpandableScreen>
  );
}
